import { CalfEntryRequirementsInput, NewCalfEntryInput } from '@/types.gql';

export type CalfEntryState = {
  requirements: CalfEntryRequirementsInput;
  calves: NewCalfEntryInput[];
};

export enum NavelStatus {
  GOOD_DRY = 'Good/Dry',
  MONITOR_RECHECK = 'Monitor/Recheck',
  START_TREATMENT = 'Start Treatment',
}

export type LabelNumericValue = {
  label: string;
  value: number;
};

export type YardPartial = {
  id: string;
  name: string;
};

export type PenPartial = {
  id: string;
  name: string;
  yard: YardPartial;
};

export type BreedPartial = {
  id: string;
  name: string;
};

export type StringMapPartial = {
  attributeValue: string;
  value: string;
};

export type NewCalfEntryInputExtended = NewCalfEntryInput & {
  pen?: PenPartial | null;
  penName?: string | null;
  breed?: BreedPartial | null;
  breedName?: string | null;
};
